import {Plan} from "@/lib/types/billing";

export const PlanFeatures: Record<string, string[]> = {
  [Plan.Premium]: [
    "200+ Basic Checks",
    "Unlimited User Accounts",
    "15+ Transaction Checks",
    "Unlimited Global + Check Locations",
    "20+ API Checks",
    "15 Locations Per Check",
    "5+ Page Speed Checks",
    "1 Min Minimum Check Frequency",
    "5+ Cloud Status Checks",
    "1.5m Real User Monitoring Page-views",
    "15+ Group Checks",
    "3+ Private Location Monitors",
    "4+ Status Pages",
  ],
};
